export default __webpack_public_path__ + "static/media/Belt of the Ostiary.d493ad6b.jpg";